var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-editor-panel"},[_c('quill-editor',{ref:"quillEditor",attrs:{"options":_vm.editorOption},on:{"change":_vm.onChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }